import React, {useEffect, useRef, useState} from 'react';
import parse from 'html-react-parser';
import {useTranslation} from "react-i18next";
import {errorRandomReplace} from "../../../util/Validation";
import './onboard-credit-card-style.scss';
import './onboard-credit-card-date-style.scss';

const classNames = require('classnames');

const OnboardCreditCardDate = (props) => {
    const {t} = useTranslation();

    const {
        error,
        onChange
    } = props;

    const inputRef = useRef();
    const inputRef2 = useRef();

    const length = 2;
    const [mValue, setMValue] = useState("");
    const [mValueYear, setMValueYear] = useState("");
    const [mError, setMError] = useState(error);
    const regex = /^\d+$/;

    useEffect(() => {
        setMError(error);
    }, [error]);

    const handleChange = (val) => {
        let text = val.target.value;

        let matches = regex.test(text);
        if (!matches && text.length !== 0) return;

        if (parseInt(text) > 12) return;

        if (text.length > length) return;

        if (error !== undefined) {
            setMError(null);
        }

        setMValue(text);
        if (onChange !== undefined)
            onChange(text + "/" + mValueYear);

        if (text.length === 2)
            inputRef2.current?.focus();
    }

    const handleChangeYear = (val) => {
        let text = val.target.value;

        let matches = regex.test(text);
        if (!matches && text.length !== 0) return;

        if (text.toString()?.length === 3) return;

        if (text.toString()?.length > 2) text = text.toString()?.substring(text.length - 2, text.length);

        if (error !== undefined) {
            setMError(null);
        }

        setMValueYear(text);
        if (onChange !== undefined)
            onChange(mValue + "/" + text);
    }

    const setClassName = () => {
        return classNames({
            'onboard-credit-card-inp-error-left': mError
        })
    }

    const setClassNameRight = () => {
        return classNames({
            'onboard-credit-card-inp-error-right': mError
        })
    }

    const blurOn = (e) => {
        if (e.target?.value?.length === 1 && mValue !== "0")
            setMValue("0" + mValue)
    }

    const selectOn = () => {
        if (mValue === "")
            inputRef.current?.focus();
        if (mValue.length === 1)
            setMValue("0" + mValue)
    }

    const handleKeyDownYear = (e) => {
        if (e.keyCode === 8 && mValueYear.length === 0) {
            inputRef.current?.focus();
        }
    }

    const blurOnYear = (e) => {
        if (mValueYear.length === 1)
            setMValueYear("0" + mValueYear)
        if (mValueYear.length > 2)
            setMValueYear(mValueYear.toString().substring(mValueYear.length - 2, mValueYear.length));
    }

    return (
        <div className="onboard-credit-card-root">
            <div className="onboard-credit-card-date-root">

                <input ref={inputRef}
                       type='text'
                       inputMode='numeric'
                       placeholder="&nbsp;"
                       value={parse(mValue)}
                       onChange={(e) => handleChange(e)}
                       className={setClassNameRight()}
                       onBlur={(e) => blurOn(e)}
                       id="cardExpirationMonth"
                       autoComplete="cc-exp-month"
                >
                </input>

                <input ref={inputRef2}
                       type='text'
                       inputMode='numeric'
                       placeholder="&nbsp;"
                       value={parse(mValueYear)}
                       onChange={(e) => handleChangeYear(e)}
                       onSelect={selectOn}
                       onKeyDown={(e) => handleKeyDownYear(e)}
                       onBlur={(e) => blurOnYear(e)}
                       className={setClassName()}
                       id="cardExpirationYear"
                       autoComplete="cc-exp-year"
                >
                </input>

                <p className={"cardExpirationSpe " + (mError ? 'onboard-credit-card-inp-error-label' : '')}>/</p>

                <div
                    className={"onboard-credit-card-date-label " + (mError ? 'onboard-credit-card-inp-error-label' : '')}>
                    {t('payment.credit_card.expiry_date')}
                </div>

                <span className="onboard-credit-card-focus-bg"></span>

            </div>

            {mError && (<div className="onboard-credit-card-error-hint">{errorRandomReplace(mError)}</div>)}

        </div>
    )
};

export default OnboardCreditCardDate;
